// extracted by mini-css-extract-plugin
export var label = "_bn-1";
export var reminder = "_bn-0";